export interface DancerDto {
  firstName: String;
  lastName: String;
  personalNumber: String;
  homeAddress: String;
  mobileNumber: String;
  email: String;
  danceLike: String;
  comments: String;

}

export class DancerService {
}
